
export const LOAD_PAGAMENTOS_PENDENTES = 'LOAD_PAGAMENTOS_PENDENTES';
export const GET_PAGAMENTOS_PENDENTES = 'GET_PAGAMENTOS_PENDENTES';
export const PAGAMENTOS_PENDENTES_ERROR = 'PAGAMENTOS_PENDENTES_ERROR';
export const MUDAR_STATUS_PAGAMENTO_PROCESSO = 'MUDAR_STATUS_PAGAMENTO_PROCESSO';
